import {
  AvailableSlideTransition,
  renderComponentsMethod as SliderRenderComponentsMethod,
  renderComponentsParams as SliderRenderComponentsParams,
  SlideProps,
  SliderProps,
} from './Slider.types';

import Slider from './Slider';

export {
  AvailableSlideTransition,
  SlideProps,
  Slider,
  SliderProps,
  SliderRenderComponentsMethod,
  SliderRenderComponentsParams,
};
